import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Button, Flex } from 'design-system-web';
import { ICON_SET_FONTAWESOME } from 'lane-shared/helpers/constants/icons';

const TRANSLATION_KEYS = {
  approve: 'web.admin.channel.visitor.log.pendingApproval.action.approve',
  deny: 'web.admin.channel.visitor.log.pendingApproval.action.deny',
};

export interface ApprovalActionButtonsProps {
  onApprove: () => void;
  onDeny: () => void;
  isLoading?: boolean;
}

export function ApprovalActionButtons({
  onApprove,
  onDeny,
  isLoading = false,
}: ApprovalActionButtonsProps) {
  const { t } = useTranslation();

  return (
    <Flex gap={4}>
      <Button
        variant="secondary"
        onClick={onDeny}
        disabled={isLoading}
        size="large"
        startIcon={<Icon name="times-circle" set={ICON_SET_FONTAWESOME} />}
      >
        {t(TRANSLATION_KEYS.deny)}
      </Button>
      <Button
        variant="primary"
        onClick={onApprove}
        disabled={isLoading}
        size="large"
        startIcon={<Icon name="check-circle" set={ICON_SET_FONTAWESOME} />}
      >
        {t(TRANSLATION_KEYS.approve)}
      </Button>
    </Flex>
  );
}

